import {
  AdminPanelSettingsOutlinedIcon,
  BusinessOutlinedIcon,
  CalendarTodayIcon,
  DashboardOutlinedIcon,
  DescriptionOutlinedIcon,
  DesktopWindowsOutlinedIcon,
  GroupOutlinedIcon,
  HomeOutlinedIcon,
  ManageAccountsOutlinedIcon,
  NoAccountsOutlinedIcon,
  PlaceOutlinedIcon,
  SettingsOutlinedIcon,
  UploadFileOutlinedIcon,
} from '@shared/components';

export type IconName =
  | 'HOME'
  | 'EXAM_EVENTS'
  | 'PROCTORING'
  | 'EXAM_RESULT'
  | 'EXAM_LOCATION'
  | 'PROCTORS'
  | 'EXAM_CENTERS'
  | 'QSET_DISTRIBUTION'
  | 'BLOCKLIST'
  | 'IDENTIFICATION'
  | 'SETTINGS'
  | 'ADMIN_DASHBOARD'
  | 'ADMIN';

export const iconMapper: Record<string, JSX.Element> = {
  HOME: <HomeOutlinedIcon />,
  EXAM_EVENTS: <CalendarTodayIcon />,
  PROCTORING: <DesktopWindowsOutlinedIcon />,
  EXAM_RESULT: <DescriptionOutlinedIcon />,
  EXAM_LOCATION: <PlaceOutlinedIcon />,
  PROCTORS: <ManageAccountsOutlinedIcon />,
  EXAM_CENTERS: <BusinessOutlinedIcon />,
  QSET_DISTRIBUTION: <UploadFileOutlinedIcon />,
  BLOCKLIST: <NoAccountsOutlinedIcon />,
  IDENTIFICATION: <GroupOutlinedIcon />,
  SETTINGS: <SettingsOutlinedIcon />,
  ADMIN_DASHBOARD: <DashboardOutlinedIcon />,
  ADMIN: <AdminPanelSettingsOutlinedIcon />,
};
